import ReactGA from 'react-ga';

ReactGA.initialize('UA-115026358-1'); //Unique Google Analytics tracking number

export default ReactGA;




// WEBPACK FOOTER //
// ./src/libs/googleAnalyticsConfig.js